/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Wednesday_May_1312Inputs */

const en__field_enum_wednesday_may_1312 = /** @type {(inputs: _Field_Enum_Wednesday_May_1312Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wednesday, May 13, 2026`)
};

const de__field_enum_wednesday_may_1312 = /** @type {(inputs: _Field_Enum_Wednesday_May_1312Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittwoch, 13.05.2026`)
};

/**
* | output |
* | --- |
* | "Wednesday, May 13, 2026" |
*
* @param {_Field_Enum_Wednesday_May_1312Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_wednesday_may_1312 = /** @type {((inputs?: _Field_Enum_Wednesday_May_1312Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Wednesday_May_1312Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_wednesday_may_1312(inputs)
	return de__field_enum_wednesday_may_1312(inputs)
});
export { _field_enum_wednesday_may_1312 as "_field_enum_WEDNESDAY_MAY_13" }